// extracted by mini-css-extract-plugin
export default {"content":"_D-z"};